import i18n from 'i18next';

import { confirmationActionTypes } from '@/components/modals/confirmation/Constants';

import type { ConfirmationActions } from '@/components/modals/confirmation/Actions';
import type { ConfirmationState } from '@/components/modals/confirmation/types';

const initialState: ConfirmationState = {
	loading: false,
	error: '',
	isOpenConfirmationModal: false,
	description: '',
	withPassword: false,
	submitModal: null,
	closeModal: null,
	title: '',
	submitBtnIcon: 'icon-trash-can',
	submitBtnTitle: i18n.t('general.remove'),
	classnames: '',
};

export default function confirmationReducer(
	state = initialState,
	action: ConfirmationActions,
): ConfirmationState {
	const { type } = action;

	switch (type) {
		case confirmationActionTypes.TOGGLE_CONFIRMATION_MODAL: {
			const { data } = action.payload;
			return {
				...state,
				loading: false,
				...data,
			};
		}
		case confirmationActionTypes.CLEAR_CONFIRMATION_MODAL_STATE:
			return initialState;

		default:
			return state;
	}
}
